import { PagePopup, PopupCloseType } from "../../Controls/PagePopup";
import { MeasureEditFactoryConfig } from "./MeasureEditFactoryConfig";

export class MeasureEditFactory {

    public static showMeasure = (config: MeasureEditFactoryConfig) => {
        let url = "~/Measure/Edit/" + config.measureId;
        url += "/" + config.templateId;
        url += "/" + config.parentId;
        url += "/" + config.parentGuid;
        if (config.additionalAction) {
            url += "/" + config.additionalAction;
        }

        const popup = new PagePopup({
            url: url,
            resultId: config.measureId,
            fullScreen: config.fullScreen,
            showCloseButton: false,
            onClose: (reason: PopupCloseType, id: number): boolean => {
                if (reason == "cancel") {
                    if (config.onClose) {
                        config.onClose(reason, config.measureId);
                    }
                }
                else if (config.onClose) {
                    config.onClose(reason, id);
                }

                let params = new URLSearchParams(window.location.search);
                if (params.has("openMeasure")) {
                    let newUrl = window.location.href.substring(0, window.location.href.indexOf('?'));
                    window.history.pushState({}, "", newUrl);
                }
                return true;
            }

        });
    }
}